import { Column, Row } from '@atom-web/micros'
import { useContext, useEffect, useState } from 'react'

import isNumeric from '../../../utils/isNumeric'
import isEmpty from '../../../utils/lodashUtils/isEmpty'
import { GCM_PASSENGER_INFO, SET_ENABLE_GET_COST } from '../Constants'
import Input from '../micros/Input'

export default ({
	itineraryInfo,
	isLoggedIn,
	context,
	contextKey,
	disabled,
	type = GCM_PASSENGER_INFO,
	defaultLoginData,
}) => {
	const [state, dispatch] = useContext(context)
	const [inputValue, setInputValue] = useState({})
	const [showEmail, setShowEmail] = useState(true)

	const entryPoint = state?.[contextKey]

	useEffect(() => {
		if (isEmpty(entryPoint?.mobileNumber) && isEmpty(entryPoint?.email)) {
			setShowEmail(true)
		} else if (
			!isEmpty(entryPoint?.email) &&
			isEmpty(entryPoint?.mobileNumber)
		) {
			setShowEmail(true)
		} else if (
			isEmpty(entryPoint?.email) &&
			!isEmpty(entryPoint?.mobileNumber) &&
			showEmail
		) {
			setShowEmail(false)
		}
	}, [entryPoint])

	useEffect(() => {
		if (defaultLoginData?.alreadyExist) {
			if (defaultLoginData?.status === 'MOBILE_EXISTS') {
				setShowEmail(false)
			}
		}
	}, [defaultLoginData])

	const onChangeEmail = email => {
		if (isEmpty(entryPoint?.email) && isNumeric(email)) {
			dispatch({
				type,
				payload: {
					mobileNumber:
						!inputValue?.email && isNumeric(email)
							? email
							: entryPoint?.mobileNumber,
					countryPhoneCode: inputValue.countryPhoneCode || '+91',
				},
			})
			setShowEmail(false)
		} else {
			dispatch({
				type,
				payload: {
					email,
					mobileNumber:
						!inputValue?.email && isNumeric(email)
							? email
							: entryPoint?.mobileNumber,
					countryPhoneCode: inputValue.countryPhoneCode || '+91',
				},
			})

			dispatch({
				type: SET_ENABLE_GET_COST,
				payload: {
					itineraryInfo,
					isLoggedIn,
				},
			})
			setInputValue({
				...inputValue,
				email,
				mobileNumber: !inputValue?.email && isNumeric(email) ? email : null,
			})
		}
	}
	const onChangeMobile = mobileNumber => {
		dispatch({
			type,
			payload: {
				mobileNumber,
				email: isEmpty(mobileNumber) ? '' : entryPoint?.email,
				countryPhoneCode: inputValue.countryPhoneCode || '+91',
			},
		})

		dispatch({
			type: SET_ENABLE_GET_COST,
			payload: {
				itineraryInfo,
				isLoggedIn,
			},
		})
		setInputValue({
			...inputValue,
			mobileNumber,
			email: isEmpty(mobileNumber) ? '' : inputValue?.email,
		})
	}
	const onChangeCountryCode = countryPhoneCode => {
		countryPhoneCode = countryPhoneCode.replace('+', '')
		if (isNaN(countryPhoneCode)) return false
		dispatch({
			type,
			payload: {
				...entryPoint,
				countryPhoneCode: '+' + countryPhoneCode,
			},
		})
		dispatch({
			type: GCM_PASSENGER_INFO,
			payload: {
				countryPhoneCode: '+' + countryPhoneCode,
			},
		})

		dispatch({
			type: SET_ENABLE_GET_COST,
			payload: {
				itineraryInfo,
				isLoggedIn,
			},
		})
	}

	return (
		<Column
			css={{
				gap: 0,
			}}
		>
			{showEmail ? (
				<Input
					placeholder="Enter Email/Mobile number"
					value={entryPoint?.email}
					onChange={onChangeEmail}
					inputProps={{
						type: 'email',
						autoFocus: true,
					}}
					ignoreCheck
					disabled={disabled}
				/>
			) : (
				<Row
					gap="2"
					css={{
						width: '100%',
					}}
				>
					<Input
						placeholder="+91"
						value={entryPoint?.countryPhoneCode}
						onChange={onChangeCountryCode}
						inputProps={{
							css: {
								paddingLeft: '$4',
								paddingTop: 0,
								fontSize: '$2',
								width: '60px',
								display: 'flex',
								justifyContent: 'center',

								'&:focus': {
									border: 'none',
								},
							},
						}}
						disabled={disabled}
						animated={false}
					/>
					<Input
						placeholder={'Enter Mobile number'}
						value={entryPoint?.mobileNumber}
						onChange={onChangeMobile}
						inputProps={{
							css: {
								width: '254px',
								backgroundColor: '$white',
							},
							autoFocus: true,
							type: 'number',
							pattern: '[0-9]*',
							max: 9999999999,
							min: 1,
						}}
						disabled={disabled}
					/>
				</Row>
			)}
		</Column>
	)
}
